import React, { ComponentProps, PropsWithChildren } from 'react';
import { Platform, StyleSheet, View, ViewProps } from 'react-native';

import { Main } from '@expo/html-elements';
import { theme } from '@garnish/constants';
import { Container, useResponsive } from '@garnish/core';
import { useNavbarContainerHeight } from '@garnish/navigation';

// ─────────────────────────────────────────────────────────────────────────────

export const HomePostOrderContent = (props: ViewProps) => {
  const { match } = useResponsive();
  const { paddingTopStyle: navbarPaddingTopStyle } = useNavbarContainerHeight();
  const style = props.style as ComponentProps<typeof Main>['style'];
  const postOrderSMStyles = [
    styles.postOrderSM,
    Platform.OS === 'web' ? styles.postOrderSMWeb : undefined,
    navbarPaddingTopStyle,
  ];

  return (
    <Main style={[match([styles.postOrderXS, postOrderSMStyles]), style]}>{props.children}</Main>
  );
};

const HomePostOrderContentInfo = (props: PropsWithChildren) => {
  return <View style={styles.postOrderInfo}>{props.children}</View>;
};

const HomePostOrderContentFooter = (props: PropsWithChildren) => {
  return (
    <Container wrapperStyle={styles.postOrderFooterWrapper} style={styles.postOrderFooter}>
      {props.children}
    </Container>
  );
};

HomePostOrderContent.Info = HomePostOrderContentInfo;
HomePostOrderContent.Footer = HomePostOrderContentFooter;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  postOrderXS: {
    flexGrow: 1,
    gap: theme.spacing['2'],
  },
  postOrderSM: {
    flexGrow: 1,
  },
  // NOTE: Native already fills the screen via `flexGrow`; a fixed minimum overflows short windows.
  postOrderSMWeb: {
    minHeight: 1024,
  },
  postOrderInfo: {
    flex: 1,
    gap: theme.spacing['6'],
    alignItems: 'flex-end',
    alignSelf: 'flex-end',
  },
  postOrderFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing['10'],
    gap: theme.spacing['4'],
  },
  postOrderFooterWrapper: {
    marginTop: 'auto',
  },
});
